module.exports = __webpack_public_path__ + "static/media/FAQ_Header.ba44fc6c.jpg";